module.exports = __webpack_public_path__ + "images/Shape784a5a6a3bc8bf670fc9be84af5eae2e.svg";